'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Header = function Header() {
  var styles = require('./Header.scss');

  return _react2.default.createElement(
    'div',
    { id: 'header', className: styles.container },
    _react2.default.createElement(
      'div',
      { id: 'header-content' },
      _react2.default.createElement(
        'header',
        { className: styles.header },
        _react2.default.createElement('div', { className: styles.controls })
      )
    )
  );
};

exports.default = Header;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/Header.js
// module id = 1161
// module chunks = 0